<template>
  <v-card
    loader-height="8"
    :loading="admin.systemsLoading"
    :disabled="admin.systemsLoading"
    min-width="600"
    :min-height="minCardHeight"
    :class="transparent"
  >
    <v-toolbar color="blue darken-2" class="text-h4 text-uppercase" dark>
      {{ tabName }}
      <v-spacer></v-spacer>

      <v-icon>{{ app.systemIcon }}</v-icon>
    </v-toolbar>
    <v-card-text v-show="admin.selectedSystem == null"></v-card-text>
    <v-card-text v-show="admin.selectedSystem != null">
      <v-overlay :opacity="0.9" absolute :value="showSaveOverlay">
        <v-btn color="success"> System saved </v-btn>
      </v-overlay>
      <v-form v-model="valid">
        <v-text-field
          v-model="name"
          :rules="validation.length50"
          label="System Name"
          required
          autofocus
        ></v-text-field>
        <v-text-field
          v-model="description"
          :rules="validation.length250"
          label="System Description"
          required
        ></v-text-field>
        <v-text-field
          v-model="systemType"
          :rules="validation.length25"
          label="System Type"
          required
        ></v-text-field>
        <v-checkbox
          color="blue darken-2"
          v-model="published"
          label="Published"
        ></v-checkbox>
      </v-form>
    </v-card-text>
    <v-card-actions v-show="admin.selectedSystem != null">
      <v-spacer />
      <v-btn dark color="blue darken-2" @click="saveSystem" :disabled="!valid"
        >save</v-btn
      >
      <v-btn color="gray" @click="closeDialog">close</v-btn>
      <!-- <v-btn icon color="error" @click="confirmDeleteSystem"
        ><v-icon>mdi-trash-can</v-icon></v-btn
      > -->
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    props: {
      minCardHeight: Number
    },
    components: {},
    data() {
      return {
        showSaveOverlay: false,
        showConfirmDelete: false,
        valid: false
      };
    },
    computed: {
      ...mapState(['app', 'admin']),
      transparent: {
        get() {
          return this.admin.selectedSystem ? '' : 'skeleton';
        }
      },
      tabName: {
        get() {
          let tabName = 'Edit System';
          if (
            this.admin.selectedSystem &&
            this.admin.selectedSystem.id != 'new'
          ) {
            tabName = `Edit System [${this.name}]`;
          } else if (
            this.admin.selectedSystem &&
            this.admin.selectedSystem.id == 'new'
          ) {
            tabName = 'Add New System';
          }
          return tabName;
        }
      },
      id: {
        get() {
          return this.admin.selectedSystem?.id;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedSystem',
            property: 'id',
            value: value
          });
        }
      },
      name: {
        get() {
          return this.admin.selectedSystem?.name;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedSystem',
            property: 'name',
            value: value
          });
        }
      },
      description: {
        get() {
          return this.admin.selectedSystem?.description;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedSystem',
            property: 'description',
            value: value
          });
        }
      },
      systemType: {
        get() {
          return this.admin.selectedSystem?.systemType;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedSystem',
            property: 'systemType',
            value: value
          });
        }
      },
      published: {
        get() {
          return this.admin.selectedSystem?.published;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedSystem',
            property: 'published',
            value: value
          });
        }
      }
    },
    methods: {
      /**
       * Show confirm dialog
       */
      confirmDeleteSystem() {
        this.showConfirmDelete = true;
      },
      /**
       * Deletes the currently selected system
       */
      deleteSystem() {
        this.$store.commit('admin/deleteSelectedSystem');
      },
      /**
       * Cancels upsert of a system
       */
      closeDialog() {
        this.$store.commit('admin/setShowEditSystemDialog', false);
      },
      /**
       * Saves the system currently being edited
       */
      saveSystem() {
        this.$store.dispatch('admin/saveSelectedSystem').then(() => {
          this.showSaveOverlay = true;
          // refresh system list
          this.$store.dispatch('admin/getSystemList');
          setTimeout(() => {
            this.showSaveOverlay = false;
            this.$store.commit('admin/setShowEditSystemDialog', false);
          }, 1500);
        });
      }
    }
  };
</script>

<style scoped></style>
